import { Outlet } from "react-router-dom";

/**
 * ExternalLayout — Screens without sidebar (vendor portal, external sharing).
 *
 * Structure (design-system.md §4.1 External portal screens):
 *   Screen (vertical flexbox, 100vw x 100vh)
 *   ├── Header Bar (branding + actions)
 *   └── Body (flex-1, Outlet content)
 */
export function ExternalLayout() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        overflow: "hidden",
        backgroundColor: "var(--bg-page)",
      }}
    >
      {/* Header bar */}
      <header
        style={{
          height: "56px",
          borderBottom: "1px solid var(--border-default)",
          backgroundColor: "var(--bg-sidebar)",
          display: "flex",
          alignItems: "center",
          padding: "0 32px",
          flexShrink: 0,
        }}
      >
        <span
          style={{
            fontSize: "20px",
            fontFamily: "'JetBrains Mono', monospace",
            fontWeight: 500,
            letterSpacing: "3px",
            color: "var(--text-primary)",
          }}
        >
          KIBORG
        </span>
      </header>

      {/* Page body */}
      <div
        style={{
          flex: 1,
          display: "flex",
          overflow: "hidden",
        }}
      >
        <Outlet />
      </div>
    </div>
  );
}
